import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  CustomCol,
  FormLabels,
  CustomInputNumber,
  ProjectBrokerageTabs,
  PurchaseBrokerageVintageSelector
} from 'src/components'
import {
  isPurchaseTab,
  validateProjectIdForStockSale,
  resetValidateEmailForStockSaleState,
  validateProjectIdForStockSaleSelector,
} from 'src/features'

const BrokerageProjectIdField: React.FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const isPurchaseTabValue = useAppSelector(isPurchaseTab)

  /* Validate Project Id Selector */
  const {
    project,
    response: validateProjectIdResponse,
  } = useAppSelector(validateProjectIdForStockSaleSelector)

  const projectIdHasError = ['ERROR'].includes(validateProjectIdResponse)

  const handleProjectIdChange = (projectId: number) => {
    if (!projectId) { dispatch(resetValidateEmailForStockSaleState()) }
    else { dispatch(validateProjectIdForStockSale(projectId, true)) }
  }

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('admin.Brokerage.ProjectId')}
        subtitle={t('general.RequiredField')}
      />
    </CustomCol>
    <CustomCol>
      <CustomInputNumber
        required
        name={'projectId'}
        onChange={handleProjectIdChange}
        placeholder={t('admin.Brokerage.ProjectIdPlaceHolder')}
      />
      {!isPurchaseTabValue && <ProjectBrokerageTabs projectIdHasError={projectIdHasError} />}
      <PurchaseBrokerageVintageSelector project={project} />
    </CustomCol>
  </Row>
}

export default BrokerageProjectIdField
